/* tslint:disable */
/* eslint-disable */
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { TimesheetEntry } from './TimesheetEntry';
import {
    TimesheetEntryFromJSON,
    TimesheetEntryFromJSONTyped,
    TimesheetEntryToJSON,
    TimesheetEntryToJSONTyped,
} from './TimesheetEntry';

/**
 * 
 * @export
 * @interface RoundTimesheetEntryResponse
 */
export interface RoundTimesheetEntryResponse {
    /**
     * 
     * @type {TimesheetEntry}
     * @memberof RoundTimesheetEntryResponse
     */
    data: TimesheetEntry;
}

/**
 * Check if a given object implements the RoundTimesheetEntryResponse interface.
 */
export function instanceOfRoundTimesheetEntryResponse(value: object): value is RoundTimesheetEntryResponse {
    if (!('data' in value) || value['data'] === undefined) return false;
    return true;
}

export function RoundTimesheetEntryResponseFromJSON(json: any): RoundTimesheetEntryResponse {
    return RoundTimesheetEntryResponseFromJSONTyped(json, false);
}

export function RoundTimesheetEntryResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): RoundTimesheetEntryResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'data': TimesheetEntryFromJSON(json['data']),
    };
}

  export function RoundTimesheetEntryResponseToJSON(json: any): RoundTimesheetEntryResponse {
      return RoundTimesheetEntryResponseToJSONTyped(json, false);
  }

  export function RoundTimesheetEntryResponseToJSONTyped(value?: RoundTimesheetEntryResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': TimesheetEntryToJSON(value['data']),
    };
}

